'use strict';
/* jshint ignore:start */
var util = require('site/util');

var recipe = {

		addRecipeEvent: function (e) {
			var obj = {
				button_ID: e.text,
				event: 'addRecipe'
			};
			$.extend(obj, getProductData());
			dataLayer.push(obj);
		},

		printRecipeEvent: function (e) {
			var obj = {
				button_ID: e.text,
				event: 'printRecipe'
			};
			$.extend(obj, getProductData());
			dataLayer.push(obj);
		},

		viewRecipeEvent: function (e) {
			var obj = {
				button_ID: '',
				event: 'viewRecipe'
			};
			$.extend(obj, getProductData());
			dataLayer.push(obj);
		}
};
/**
 * Returns an object which contains product data
 * that is mainly identical for all GTM events that are triggered on PDP.
 * Product data is taken either from the html or from hidden input field on PDP
 *
 * @returns Object
 */
function getProductData() {
	var today = new Date();
	var dd = today.getDate();
	var mm = today.getMonth() + 1; //January is 0!
	var yyyy = today.getFullYear();
	if ($('input[name=productData]').length > 0) {
		var productObj = JSON.parse($('input[name=productData]').val());
		// object to be pushed
		var obj = {
			'product_brand': productObj.productBrand,
			'product_category': productObj.productCategory,
			'product_hierarchy': productObj.productHierarchy,
			'product_ID': productObj.productID,
			'product_image': $('.primary-image') ? $('.primary-image').prop('src') : '',
			'product_name': productObj.productName,
			'product_SKU': productObj.productSKU,
			'recipe_brand': productObj.productBrand,
			'recipe_category':  productObj.productCategory,
			'recipe_description': productObj.description,
			'recipe_ID': productObj.productID,
			'recipe_image_url': $('.primary-image') ? $('.primary-image').prop('src') : '',
			'recipe_name': productObj.productName,
			'recipe_price': productObj.price,
			're_date_added': dd + '/' + mm + '/' + yyyy
		};
		return obj;
	}
}
module.exports = recipe;
/* jshint ignore:end */
